'use es6';

import PropTypes from 'prop-types';
import { TABLE } from 'reporting-data/constants/chartTypes';
import { overrideLimitBasedOnReportHeight } from '../utils/paginate';
import ReportWithPagination from './components/ReportWithPagination';
import { jsx as _jsx } from "react/jsx-runtime";
const Report = ({
  report,
  runtimeOptions,
  disableEmptyStates,
  errorRenderer,
  noDataRenderer,
  onReportResolve,
  onError,
  setIsRendered,
  visualizationDebug,
  height,
  resolve,
  determineVisualization,
  isMobile,
  visualize,
  compact,
  mobileReportingOptions,
  vizContainerStyleProps,
  disableZoom
}) => /*#__PURE__*/_jsx(ReportWithPagination, {
  report: report.get('chartType') === TABLE ? overrideLimitBasedOnReportHeight(report, height) : report,
  runtimeOptions: runtimeOptions,
  disableEmptyStates: disableEmptyStates,
  errorRenderer: errorRenderer,
  noDataRenderer: noDataRenderer,
  onReportResolve: onReportResolve,
  onError: onError,
  setIsRendered: setIsRendered,
  visualizationDebug: visualizationDebug,
  resolve: resolve,
  determineVisualization: determineVisualization,
  isMobile: isMobile,
  visualize: visualize,
  compact: compact,
  mobileReportingOptions: mobileReportingOptions,
  vizContainerStyleProps: vizContainerStyleProps,
  disableZoom: disableZoom
});
Report.propTypes = {
  compact: PropTypes.bool,
  report: PropTypes.object,
  runtimeOptions: PropTypes.object,
  disableEmptyStates: PropTypes.bool,
  errorRenderer: PropTypes.func,
  noDataRenderer: PropTypes.func,
  onReportResolve: PropTypes.func,
  onError: PropTypes.func,
  setIsRendered: PropTypes.func,
  height: PropTypes.number,
  resolve: PropTypes.func,
  determineVisualization: PropTypes.func,
  isMobile: PropTypes.bool,
  /* For debugging v2 visualizations */
  visualizationDebug: PropTypes.object,
  visualize: PropTypes.func,
  disableZoom: PropTypes.bool
};
export default Report;